













import { Component, Mixins } from 'vue-property-decorator';
import { Warning } from '@/pages/profile/components';
import { MentoringNewRequestForm } from '@/pages/profile/modules';
import { IsChildApprovedMixin } from '@/pages/profile/mixins';
import { ParcedFormData, IMentoringNewRequests } from './types';

@Component({
  components: {
    Warning,
    MentoringNewRequestForm,
  },
})
export default class MentoringNewRequests extends Mixins(IsChildApprovedMixin)
  implements IMentoringNewRequests {
  emitRequestForm(value: ParcedFormData): void {
    this.$emit('emitRequestForm', value);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/views/newrequests/MentoringNewRequests.vue